import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Home, Store, Factory, ArrowUpRight } from "lucide-react";

const AREAS = [
  {
    icon: Home,
    title: "Privat",
    text: "Epoxidharzböden für Garagen, Keller, Hobbyräume und private Nutzflächen – hochwertig, fugenlos und pflegeleicht.",
    img: "/assets/img/epoxidharzboden-privat-hobbyraum.jpg",
    alt: "Epoxidharzboden im privaten Hobbyraum – stilvoller Kellerraum mit matter, fugenloser Bodenbeschichtung, Terbeck Service Gronau",
    testid: "area-card-privat",
  },
  {
    icon: Store,
    title: "Gewerbe",
    text: "Robuste, hochwertige Bodenbeschichtungen für Werkstätten, Verkaufs- und Gewerbeflächen – widerstandsfähig im täglichen Betrieb.",
    img: "/assets/img/epoxidharzboden-gewerbe-parkhaus-beschichtet.jpg",
    alt: "Bodenbeschichtung im Gewerbebereich – beschichtete Gewerbefläche mit sauberer Oberfläche, Terbeck Service",
    testid: "area-card-gewerbe",
  },
  {
    icon: Factory,
    title: "Industrie",
    text: "Professionelle Bodenbeschichtungen für Lagerhallen und größere gewerbliche und industrielle Flächen – planbar und belastbar.",
    img: "/assets/img/epoxidharzboden-industrie-lagerhalle.jpg",
    alt: "Bodenbeschichtung für Industrie und Lagerhallen – großflächiger Industrieboden, Terbeck Service Gronau",
    testid: "area-card-industrie",
  },
];

export const EpoxyAreas = () => (
  <section data-testid="epoxy-areas-section" className="bg-surface border-b border-white/10 py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-5 md:px-8">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-14 md:mb-20"
      >
        <p className="mb-4 text-xs font-bold tracking-[0.3em] text-brand-bright">EPOXIDHARZBÖDEN — UNSER SCHWERPUNKT</p>
        <h2 className="max-w-3xl font-display text-3xl sm:text-4xl md:text-6xl font-bold uppercase tracking-tighter text-white leading-[1.02] hyphens-auto">
          Ein Boden.<br />
          <span className="text-white/40">Drei Einsatz&shy;bereiche.</span>
        </h2>
        <p className="mt-6 max-w-2xl text-sm md:text-base leading-relaxed text-white/55">
          Ob private Garage, Werkstatt oder Lagerhalle: Wir beschichten Böden für private,
          gewerbliche und industrielle Anwendungen – immer mit derselben Sorgfalt bei der
          Untergrundvorbereitung und Ausführung.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {AREAS.map((a, i) => {
          const Icon = a.icon;
          return (
            <motion.div
              key={a.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
            >
              <Link
                data-testid={a.testid}
                to="/epoxidharzboeden"
                className="group block overflow-hidden rounded-2xl border border-white/10 bg-ink transition-[transform,border-color] duration-500 hover:-translate-y-1.5 hover:border-brand/50"
              >
                <div className="relative h-52 md:h-60 overflow-hidden">
                  <img
                    src={a.img}
                    alt={a.alt}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                    loading="lazy"
                  />
                  <span className="absolute left-5 top-5 inline-flex h-11 w-11 items-center justify-center rounded-xl bg-black/60 text-brand-bright ring-1 ring-brand/40 backdrop-blur-sm">
                    <Icon className="h-5 w-5" strokeWidth={1.75} />
                  </span>
                </div>
                <div className="p-7">
                  <h3 className="font-display text-2xl font-bold uppercase tracking-tight text-white">
                    {a.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-white/60">{a.text}</p>
                  <span className="mt-6 inline-flex items-center gap-2 text-xs font-bold tracking-[0.2em] text-brand-bright group-hover:text-white transition-colors duration-300">
                    MEHR ERFAHREN
                    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </span>
                </div>
              </Link>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
